import { render, staticRenderFns } from "./CardFactoryWages.vue?vue&type=template&id=2a2f92f5&scoped=true&"
import script from "./CardFactoryWages.vue?vue&type=script&lang=js&"
export * from "./CardFactoryWages.vue?vue&type=script&lang=js&"
import style0 from "./CardFactoryWages.vue?vue&type=style&index=0&id=2a2f92f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f92f5",
  null
  
)

export default component.exports